import React from "react";
import { Link } from "react-router-dom";

const TermsConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Navigation Bar */}
      <nav className="bg-white shadow-lg border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center py-4 sm:h-16 space-y-4 sm:space-y-0">
            {/* Logo */}
            <Link className="flex items-center" to="/">
              <img
                src="/welcome-logo.png"
                alt="Welcome Logo"
                className="h-6 sm:h-8 w-auto"
              />
            </Link>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 w-full sm:w-auto">
              <a
                href="https://play.google.com/store/apps/details?id=com.tower.app"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors w-full sm:w-auto text-center"
              >
                Descargar App
              </a>
              <Link
                to="/welcome"
                className="bg-cyan-500 hover:bg-cyan-600 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors w-full sm:w-auto text-center"
              >
                Login Tower
              </Link>
            </div>
          </div>
        </div>
      </nav>
      <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Política de Privacidad
            </h1>
            <p className="text-sm text-gray-600">
              <strong>Fecha de entrada en vigencia: 30/06/2025</strong>
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              En <strong>Gonau</strong>, valoramos la privacidad y la seguridad
              de los datos personales de nuestros usuarios. Esta Política de
              Privacidad describe qué información recopilamos, cómo la
              utilizamos, cómo la protegemos y qué derechos tienen los usuarios
              sobre sus datos.
            </p>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                1. Información que recopilamos
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Información de Conductores:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Nombre completo</li>
                    <li>Dirección de correo electrónico</li>
                    <li>Número de teléfono</li>
                    <li>Dirección física</li>
                    <li>Documento de identidad</li>
                    <li>Fotografía de perfil (opcional)</li>
                    <li>Tipo de trabajador y vehículo</li>
                    <li>
                      Estadísticas de rendimiento (órdenes completadas,
                      rechazadas, reasignadas)
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Información de Clientes (para entregas):
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Nombre completo</li>
                    <li>Número de teléfono</li>
                    <li>Direcciones de entrega</li>
                    <li>Coordenadas GPS de entrega</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Datos de Ubicación:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Ubicación en tiempo real y en segundo plano</li>
                    <li>Historial de ubicaciones</li>
                    <li>Velocidad, dirección, altitud y precisión GPS</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Información del Dispositivo:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Modelo y marca del dispositivo</li>
                    <li>Versión del sistema operativo</li>
                    <li>Identificador único</li>
                    <li>Nivel de batería</li>
                    <li>Estado de conexión a internet</li>
                    <li>Configuración de volumen</li>
                    <li>Token de notificaciones push</li>
                  </ul>
                </div>
              </div>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                2. Permisos del dispositivo
              </h2>
              <p className="text-gray-700 mb-3">La app solicita acceso a:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>
                  Ubicación precisa y aproximada (incluida en segundo plano)
                </li>
                <li>Conexión a Internet y estado de red</li>
                <li>Notificaciones push y vibración</li>
                <li>
                  Inicio automático y exclusión de optimización de batería
                </li>
                <li>Almacenamiento externo (Android 10-)</li>
                <li>Cámara y galería (para fotos de perfil)</li>
                <li>Consulta de aplicaciones instaladas</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                3. Servicios de terceros utilizados
              </h2>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>
                  <strong>Autenticación:</strong> Auth0, JWT
                </li>
                <li>
                  <strong>Mapas y navegación:</strong> Google Maps API,
                  Directions API, Geolocator
                </li>
                <li>
                  <strong>Notificaciones:</strong> Firebase Cloud Messaging
                  (FCM)
                </li>
                <li>
                  <strong>Comunicación en tiempo real:</strong> MQTT, WebSocket
                </li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                4. Finalidades del tratamiento de datos
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Operación del Servicio:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Asignar órdenes automáticamente</li>
                    <li>Navegación y optimización de rutas</li>
                    <li>Seguimiento en tiempo real</li>
                    <li>Gestión de check-in y check-out</li>
                    <li>Notificaciones de órdenes disponibles</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Geofencing:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Detección de ingreso/salida de zonas</li>
                    <li>Notificaciones basadas en ubicación</li>
                    <li>Optimización de asignación por proximidad</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Seguridad:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Autenticación y verificación de identidad</li>
                    <li>Prevención de usos indebidos</li>
                    <li>Auditoría de actividades</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Mejora del servicio:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Análisis de rendimiento</li>
                    <li>Estadísticas de uso</li>
                    <li>Optimización de experiencia y rutas</li>
                  </ul>
                </div>
              </div>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                5. Almacenamiento y retención de datos
              </h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Almacenamiento local:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Datos de sesión y autenticación cifrados</li>
                    <li>Preferencias del usuario</li>
                    <li>Caché de mapas y rutas</li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-lg font-medium text-gray-800 mb-3">
                    Almacenamiento en servidores:
                  </h3>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>Perfiles y registros de órdenes</li>
                    <li>Historial de ubicaciones</li>
                    <li>Métricas de rendimiento</li>
                  </ul>
                </div>
              </div>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                6. Comunicaciones electrónicas
              </h2>
              <p className="text-gray-700 mb-3">
                Se podrán enviar notificaciones para:
              </p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>Órdenes asignadas y actualizaciones</li>
                <li>Alertas de proximidad</li>
                <li>Estados de entrega</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                7. Funcionalidades en segundo plano
              </h2>
              <p className="text-gray-700 mb-3">Incluso con la app cerrada:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>Monitoreo de ubicación para órdenes</li>
                <li>Sincronización automática de datos</li>
                <li>Reconexión a servicios en tiempo real</li>
                <li>Servicios de mantenimiento y notificaciones activas</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                8. Integraciones externas
              </h2>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>Aplicaciones de email</li>
                <li>Navegadores web</li>
                <li>Configuraciones del sistema operativo</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                9. Derechos del usuario
              </h2>
              <p className="text-gray-700 mb-3">Los usuarios pueden:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>Acceder a sus datos</li>
                <li>Corregir información</li>
                <li>Eliminar su cuenta y datos</li>
                <li>Solicitar portabilidad</li>
                <li>Revocar consentimientos</li>
                <li>Restringir el procesamiento</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                10. Medidas de seguridad
              </h2>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>Cifrado de datos en tránsito y reposo</li>
                <li>Autenticación multifactor (Auth0)</li>
                <li>Tokens JWT con expiración</li>
                <li>HTTPS y WSS para comunicaciones seguras</li>
                <li>Auditoría de accesos y modificaciones</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                11. Cumplimiento legal
              </h2>
              <p className="text-gray-700 mb-3">Cumplimos con:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                <li>Leyes locales de protección de datos</li>
                <li>Regulaciones aplicables al transporte y logística</li>
              </ul>
            </section>

            <hr className="my-8 border-gray-200" />

            <div className="bg-gray-50 p-6 rounded-lg mt-8">
              <p className="text-gray-700">
                Para ejercer tus derechos o realizar consultas, contáctanos a
                través de{" "}
                <a
                  href="mailto:info@iungo.co"
                  className="text-cyan-500 hover:text-cyan-600"
                >
                  info@iungo.co{" "}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
